module.exports = __webpack_public_path__ + "img/who-du-nelson-1406613-unsplash.bdb00d84.jpg";